'use strict';

var FirebaseObject = require('./FirebaseObject');
var KayleeBase = require('./KayleeBase');
var KayleeCache = require('./KayleeCache');

var KayleeKayleeInfo = {
    fromJson: fromJson,
    get: getKayleeInfo,
};

function fromJson(data) {
    var reqProps = [];
    return FirebaseObject.$fromJson(data, 'KayleeInfo', reqProps, reqProps,
        function(data) { return getKayleeInfo(); }
    );
}

function getKayleeInfo() {
    var key = 'KayleeInfo';
    var kayleeInfo = KayleeCache.get(key);

    if (kayleeInfo === null) {
        kayleeInfo = new KayleeInfo();
        KayleeCache.put(key, kayleeInfo);
    }

    return kayleeInfo;
}

function KayleeInfo() {
    this.$nodeType = 'kayleeInfo';
    FirebaseObject.call(this,
        KayleeBase.app.database().ref('kaylee'));
}

KayleeInfo.prototype = Object.create(FirebaseObject.prototype);
KayleeInfo.prototype.constructor = KayleeInfo;

KayleeInfo.prototype.$toJson = function() {
    return FirebaseObject.prototype.$toJson.call(this, []);
};

KayleeInfo.prototype.toString = function() {
    return '[Kaylee Info]';
};

module.exports = KayleeKayleeInfo;